import axios from 'axios';
import httpClient from '../httpClient';
import store from 'redux/configureStore';
const FileDownload = require('js-file-download');

export const getEntities = (advancedSettings) => {
    return httpClient
        .get(`/api/v2/entity?itemsOnPage=9999&advancedSettings=${advancedSettings ? 1 : 0}`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getEntityStatsById = (id) => {
    return httpClient
        .get(`/api/v2/entity/${id}/statistics`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getEntitySourceCount = (id) => {
    return httpClient
        .get(`/api/v2/entity/${id}/statistics`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};


export const getEntityNewsById = (id) => {
    return httpClient
        .get(`/api/v2/entity/${id}?help=false&count=false&page=1&itemsOnPage=9999&newsLimit=1000&titleLength=140&abstractLength=300`)
        // .get(`/api/v2/entity/${id}?itemsOnPage=1000`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateEntityNewsSorting = (id, sortValue) => {
    return httpClient
        .get(`/api/v2/entity/${id}/sort_update?entitySorting=${sortValue}&help=false&count=false&page=1&itemsOnPage=1000&newsLimit=1000&titleLength=140&abstractLength=300`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const updateGoogleOzmosysSource = (entityId, sourceId, params) => {
    return httpClient
        .patch(`/api/v2/google_news/${entityId}/edit/${sourceId}`, params)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getEntityCSV = (id) => {
    return httpClient
        .get(`/api/v2/entity/${id}/std_statistics`)
        .then((res) => {
            let headerLine = res.headers['content-disposition'];
            let name = headerLine.substring(headerLine.indexOf('=') + 1, headerLine.indexOf('.csv') + 4);
            FileDownload(res.data, `${name ? name : 'entity-statistics.csv'}`);
        })
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const getAutocompleteData = (url) => {
    return fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${url}`)
        // .get(`/api/v2/entity/${id}?itemsOnPage=1000`)
        .then((res) => {
            return res.json()
        })
        .then(data => {
            return data;
        })
        .catch((e) => {
            // throw e.response.data.content;
            throw(e)
        });
};

export const updateEntitySourceFilter = (id, sourceType) => {
    return httpClient
        .get(`/api/v2/entity/${id}/source_settings_preview?sourceType=${sourceType}&count=false&page=1&itemsOnPage=9999&newsLimit=1000&titleLength=140&abstractLength=300`)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};

export const checkStatus = (pendingIds) => {
    let entitiesStr = '';
    pendingIds.length > 0 && pendingIds.map(id => {
        return entitiesStr += `&entities%5B%5D=${id}`;
    });
    let url = `/api/v2/entity/statuses?${entitiesStr}`;

    return httpClient
        .get(url)
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};
